import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const salaryStructureApi = createApi({
  reducerPath: 'salaryStructureApi',
  baseQuery,
  tagTypes: ['SalaryStructure'],
  endpoints: (builder) => ({
    // Salary Structure endpoints
    getSalaryStructures: builder.query({
      query: (params = {}) => ({
        url: '/salary-structures',
        params,
      }),
      providesTags: ['SalaryStructure'],
    }),
    getSalaryStructure: builder.query({
      query: (id) => `/salary-structures/${id}`,
      providesTags: (result, error, id) => [{ type: 'SalaryStructure', id }],
    }),
    getDefaultSalaryStructure: builder.query({
      query: () => '/salary-structures/default',
      providesTags: ['SalaryStructure'],
    }),
    createSalaryStructure: builder.mutation({
      query: (structureData) => ({
        url: '/salary-structures',
        method: 'POST',
        body: structureData,
      }),
      invalidatesTags: ['SalaryStructure'],
    }),
    updateSalaryStructure: builder.mutation({
      query: ({ id, ...structureData }) => ({
        url: `/salary-structures/${id}`,
        method: 'PUT',
        body: structureData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'SalaryStructure', id }],
    }),
    deleteSalaryStructure: builder.mutation({
      query: (id) => ({
        url: `/salary-structures/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SalaryStructure'],
    }),
    calculateSalaryBreakdown: builder.mutation({
      query: (calculationData) => ({
        url: '/salary-structures/calculate',
        method: 'POST',
        body: calculationData,
      }),
    }),
  }),
});

export const {
  useGetSalaryStructuresQuery,
  useGetSalaryStructureQuery,
  useGetDefaultSalaryStructureQuery,
  useCreateSalaryStructureMutation,
  useUpdateSalaryStructureMutation,
  useDeleteSalaryStructureMutation,
  useCalculateSalaryBreakdownMutation,
} = salaryStructureApi;
